import { Box, Container, Stack, Typography, useTheme } from "@mui/material";
import { t } from "i18next";
import { Trans } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthContainer from "../../../components/AuthContainer.js";
import BackButton from "../../../components/BackButton/index.js";
import appcolors from "../../../constants/Colors.js";
import LoginForm from "./LoginForm.js";

const Login = () => {
  const { palette } = useTheme();
  const { state } = useLocation();
  const navigate = useNavigate();

  return (
    <Box>
      <AuthContainer>
        <Stack
          gap={0.5}
          top={25}
          left={20}
          right={0}
          position={"absolute"}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          paddingInlineEnd={3}
        >
          <BackButton handleBack={() => navigate("/")} />
          <Stack
            direction={"row"}
            alignItems={"center"}
            gap={0.5}
            flexShrink={0}
          >
            <Typography
              variant="body1"
              fontFamily={"Inter"}
              color={"custom.slateGrey"}
            >
              {t("createAccount")}?
            </Typography>
            <Link
              to={
                state?.type === "worker"
                  ? "/register/worker/services"
                  : `/register/${state?.type}`
              }
              className="react-router-link"
              style={{
                fontWeight: 600,
                color: palette.primary.main,
                textTransform: "capitalize",
              }}
            >
              {t("signUp")}
            </Link>
          </Stack>
        </Stack>

        <Container className={"lb-auth-container"} sx={{ mt: 5 }}>
          <Stack alignItems={"center"}>
            <Typography
              variant="auth_primary_text"
              component={"h1"}
              textTransform={"capitalize"}
            >
              {t("login")}
            </Typography>
            <Typography variant="auth_secondary_text" component={"p"}>
              <Trans
                i18nKey="welcomeLoginMessage"
                style={{ color: appcolors.slateGrey }}
                color={appcolors.slateGrey}
              >
                Welcome to <b style={{ color: "black" }}>Eaziday</b> CRM, Please
                give us email address and password
              </Trans>
            </Typography>
          </Stack>

          {/* Login form component */}
          <LoginForm />
        </Container>
      </AuthContainer>
    </Box>
  );
};

export default Login;
